document.addEventListener("scroll", () => {
  const throneSection = document.querySelector(".cat-throne-sc");
  const footstepContainer = document.querySelector(".footstep-container");

  if (!throneSection || !footstepContainer) return;

  const throneRect = throneSection.getBoundingClientRect();
  const containerBottom = footstepContainer.getBoundingClientRect().bottom;

  // Check if the throne section is in the viewport and the container has exited
  if (
    throneRect.top < window.innerHeight &&
    throneRect.bottom > 0 &&
    containerBottom < window.innerHeight
  ) {
    const footsteps = Array.from(
      document.querySelectorAll(".footstep")
    ).reverse();

    footsteps.forEach((footstep, index) => {
      setTimeout(() => {
        footstep.style.animationPlayState = "running";
      }, index * 200); // Stagger animation with a delay of 200ms
    });
  }
});
// vivek start 
// (function () {

//   document.addEventListener('click', function (e) {

//     const link = e.target.closest('.thumnails a[data-target]');
//     if (!link) return;

//     e.preventDefault();

//     const targetId = link.getAttribute('data-target');
//     const targetEl = document.getElementById(targetId);

//     if (!targetEl) {
//       console.warn('Scroll target not found:', targetId);
//       return;
//     }

//     // Small delay fixes Shopify + lazy-load issues
//     setTimeout(function () {

//       targetEl.scrollIntoView({
//         behavior: 'smooth',
//         block: 'center'
//       });

//       // Optional active state
//       document.querySelectorAll('.inex-parts-block').forEach(el => {
//         el.classList.remove('is-active');
//       });
//       targetEl.classList.add('is-active');

//     }, 150);

//   });

// })();
// vivek end 






$(document).ready(function () {
  $('.embarce-slider').slick({
    centerMode: true,
    centerPadding: '24px', // Adjust as needed for visual preference
    slidesToShow: 4.5,
    slidesToScroll: 4.5, // Matches slidesToShow for smoother scrolling
    autoplay: true,
    autoplaySpeed: 2000,
    dots: true,
    responsive: [
      {
        breakpoint: 1441,
        settings: {
          centerPadding: '20px',
          slidesToShow: 3.5,
          slidesToScroll: 3.5
        }
      },
      {
        breakpoint: 992,
        settings: {
          centerPadding: '20px',
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          centerPadding: '20px',
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          centerPadding: '20px',
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
});


$(document).ready(function () {
  var swiper = new Swiper(".st-cat-bene-fun-facts-cards-block", {
    slidesPerView: 4.5,
    spaceBetween: 40,
    loop: true,
    loopAdditionalSlides: 1,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    autoplay: {
      delay: 3000, 
      disableOnInteraction: false, 
    },
    breakpoints: {
      // Ensure breakpoint values match your design requirements
      1440: {
        slidesPerView: 3.5,
        spaceBetween: 24,
      },
      1200: {
        slidesPerView: 3.5,
        spaceBetween: 24,
      },
      992: {
        slidesPerView: 2.5,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 1.5,
        spaceBetween: 16,
      },
      550: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      370: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
    },
  });
});



// $(document).ready(function () {
//   var swiper = new Swiper(".follow-insta-slider", {
//     slidesPerView: 4.5,
//     spaceBetween: 14,
//     centeredSlides: true,
//     loop: true,
//     pagination: {
//       el: ".swiper-pagination", // Specify the pagination container
//       clickable: true,          // Make the dots clickable
//     },
//     breakpoints: {
//       1200: {
//         slidesPerView: 4.5,
//         spaceBetween: 14,
//       },
//       992: {
//         slidesPerView: 3.5,
//         spaceBetween: 20,
//       },
//       768: {
//         slidesPerView: 2.5,
//         spaceBetween: 16,
//       },
//       550: {
//         slidesPerView: 1,
//         spaceBetween: 10,
//       },
//       370: { 
//         slidesPerView: 1, 
//         spaceBetween: 12, 
//       } // <-- Added closing parenthesis here
//     }
//   });
// });


$(document).ready(function () {
  $('.premium-slide').slick({
    infinite: true,
    arrows: true,
    dots: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerPadding: '30px',
    autoplay: true, // Enable autoplay
    autoplaySpeed: 2500, // Set autoplay speed in milliseconds
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerPadding: '20px',
        }
      },
      {
        breakpoint: 820,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerPadding: '15px',
          arrows: false,
        }
      },
      {
        breakpoint: 768, 
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          autoplay: false,
          centerPadding: '10px',
        }
      }
    ]
  });
});

$(document).ready(function () {
  $('.multiple-items').slick({
    infinite: true,
    arrows: false,
    dots: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerPadding: '30px',
    autoplay: true, // Enable autoplay
    autoplaySpeed: 3000, // Set autoplay speed in milliseconds
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerPadding: '20px',
        }
      },
      {
        breakpoint: 768, 
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding: '10px',
        }
      }
    ]
  }); 
});

 $(document).ready(function () {
   var sliderSpeed = $('.banner-slider').data('slider-speed') || 6500;
          var swiper = new Swiper(".banner-slider", {
            spaceBetween: 30, 
            effect: "fade", 
            fadeEffect: {
              crossFade: true, 
            },
            loop: true, 
            autoplay: {
              // delay: 6500,
              delay: sliderSpeed, 
              disableOnInteraction: false, 
            },
            speed: 1000, 
          });
        });

$(document).ready(function () {
  // Initially, show only the first FAQ's open state and hide others
  $(".st-cat-bene-faq").each(function (index) {
    const $faq = $(this);
    const $openState = $faq.find(".st-cat-bene-faq-open-state");

    if (index === 0) {
      $openState.show(); // Show the first FAQ
      $faq.addClass("active"); // Add active class to the first FAQ
    } else {
      $openState.hide(); // Hide others
    }
  });

  // Add click event to toggle FAQ open/close states
  $(".st-cat-bene-faq-close-state").on("click", function () {
    // Find the parent .st-cat-bene-faq of the clicked SVG
    const $faq = $(this).closest(".st-cat-bene-faq");

    // Find the .st-cat-bene-faq-open-state within the clicked .st-cat-bene-faq
    const $openState = $faq.find(".st-cat-bene-faq-open-state");

    // Toggle visibility of the clicked FAQ
    if ($openState.is(":hidden")) {
      $openState.slideDown();
      $faq.addClass("active"); // Add active class to the parent FAQ when open
    } else {
      $openState.slideUp();
      $faq.removeClass("active"); // Remove active class from the parent FAQ when closed
    }

    // Hide all other FAQ open states and remove their active class
    $(".st-cat-bene-faq")
      .not($faq)
      .find(".st-cat-bene-faq-open-state")
      .slideUp();
    $(".st-cat-bene-faq")
      .not($faq)
      .removeClass("active"); // Remove active class from other FAQs
  });
});

/*------ for tabbing ------*/
$(document).ready(function () {
  // Initially activate the first tab and its content
  $('.tab').first().addClass('active');
  $('.tab-pane').first().addClass('active');
  $(".custom-form-tabs .form-tab").first().addClass('active');

  // Handle tab click event
  $('.tab').click(function () {
    // Remove 'active' class from all tabs and tab panes
    $('.tab').removeClass('active');
    $('.tab-pane').removeClass('active');
    $(".custom-form-tabs .form-tab").removeClass('active');

    // Add 'active' class to the clicked tab
    $(this).addClass('active');

    // Show the corresponding tab pane based on the clicked tab
    var tabIndex = $('.tab').index(this); // Get index of clicked tab
    $('.tab-pane').eq(tabIndex).addClass('active');

    $(".custom-form-tabs .form-tab").eq(tabIndex).addClass('active');
    
  });
});

$(document).ready(function () {
  // Initially activate the first tab and its content
  $('.custom-form-list .custom-form-tabs').first().addClass('active');

  // Handle tab click event
  $('.custom-form-list .tab').click(function () {
    
      const attr = $(this).attr("attr");
    // Add 'active' class to the clicked tab
    $(this).addClass('active');

    // Show the corresponding tab pane based on the clicked tab
    var tabIndex = $('.tab').index(this); // Get index of clicked tab
    $('.tab-pane').eq(tabIndex).addClass('active');
    $("#custom_form_type").val(attr);
  });
});






/*------ for animations ------*/
// $(document).ready(function () {
  
//   var heading = $('.main-banner-content h1');

  
//   heading.addClass('highlight');

  
//   const elementsToAnimate = $('p, h2, h1, h3').not('.tab-pane p');
//   const observerOptions = { threshold: 0.5 };

//   const observer = new IntersectionObserver(entries => {
//     entries.forEach(entry => {
//       if (entry.isIntersecting) {
//         activateAnimation($(entry.target));
//       }
//     });
//   }, observerOptions);

//   elementsToAnimate.each(function () {
//     observer.observe($(this)[0]);
//   });

//   function activateAnimation(element) {
//     if (element.prop('tagName').toLowerCase() === 'img') {
//       element.addClass("scale-animation");
//     } else {
//       element.addClass("animate");
//     }
//     observer.unobserve(element[0]);
//   }
// });





/*------ for Hamberger ------*/
$(document).ready(function() {
	// Click event for the hamburger menu
	$(".hamburger").click(function(){
			$(this).toggleClass("is-active");
			$('.menusflex').toggleClass('active');
			$('body').toggleClass('active');
			$('.backgound-overlay').toggleClass('bactive');

	});

	// Click event for the span elements
	$('.down-arrow').click(function(event) {
			event.stopPropagation(); // Prevents the event from bubbling up to the document

			var subMenu = $(this).siblings('.sub-menu');
			
			// Slide toggle for the clicked sub-menu with smooth animation
			subMenu.slideToggle(300);

			// Toggle 'sub-menu-active' class for the clicked sub-menu
			subMenu.toggleClass('sub-menu-active');

			// Slide up other sub-menus and remove 'sub-menu-active' class
			$('.sub-menu').not(subMenu).slideUp(300).removeClass('sub-menu-active');
	});

	// Click event to remove 'sub-menu-active' class from all sub-menus when clicking outside
	$(".hamburger").click(function() {
			$('.sub-menu').slideUp(300).removeClass('sub-menu-active');
	});
});


document.addEventListener("DOMContentLoaded", function () {
  // Add event listener to all elements with class 'play-icon'
  document.querySelectorAll(".play-icon").forEach((icon) => {
    icon.addEventListener("click", function () {
      const parentBlock = this.closest(".st-cat-ins-steps");

      if (parentBlock) {
        const stepGif = parentBlock.querySelector(".step-gif");
        const stepImg = parentBlock.querySelector(".step-img");
        const playImg = parentBlock.querySelector(".st-cat-ins-steps-play-img");
        const pauseImg = parentBlock.querySelector(".st-cat-ins-steps-pause-img");
        const stepImgContainer = parentBlock.querySelector(".st-cat-ins-steps-img");

        if (stepGif && stepImg && playImg && pauseImg && stepImgContainer) {
          // Toggle hidden class on stepGif
          stepGif.classList.remove("hidden");
          pauseImg.classList.remove("hidden");
          
          // Hide other elements
          stepImg.classList.add("hidden");
          playImg.classList.add("hidden");

          // Remove :before pseudo-element
          stepImgContainer.classList.add("remove-before");
        }
      }
    });
  });

  // Optional: Add event for step-gif if needed
  document.querySelectorAll(".pause-icon").forEach((gif) => {
    gif.addEventListener("click", function () {
      const parentBlock = this.closest(".st-cat-ins-steps");

      if (parentBlock) {
        const stepGif = parentBlock.querySelector(".step-gif");
        const stepImg = parentBlock.querySelector(".step-img");
        const playImg = parentBlock.querySelector(".st-cat-ins-steps-play-img");
        const pauseImg = parentBlock.querySelector(".st-cat-ins-steps-pause-img");
        const stepImgContainer = parentBlock.querySelector(".st-cat-ins-steps-img");

        if (stepGif && stepImg && playImg && pauseImg && stepImgContainer) {
          // Toggle hidden class on stepGif
          stepGif.classList.add("hidden");
          pauseImg.classList.add("hidden");

          // Hide other elements
          stepImg.classList.remove("hidden");
          playImg.classList.remove("hidden");

          // Remove :before pseudo-element
          stepImgContainer.classList.remove("remove-before");
        }
      }
    });
  });
});


document.addEventListener('DOMContentLoaded', function () {
  if (document.body.classList.contains('cat-products')) {
    document.getElementById('sort_by').addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);

      fetch(url)
        .then(response => response.text())
        .then(data => {
          var newProducts = new DOMParser()
            .parseFromString(data, 'text/html')
            .querySelector('.st-cat-shop-items-block').innerHTML;
          document.querySelector('.st-cat-shop-items-block').innerHTML = newProducts;
          window.history.pushState({}, '', url);
        })
        .catch(() => {
          // Handle errors silently or add a user-friendly error handler here if needed
        });
    });
  }
});

$(document).ready(function(){
    $('.cat-tabbing-sc .custom-form-list .tab-container .tab-content .primary-btn').on('click',function(){
      var a_href = $(this).attr('href');
      if(a_href.includes('javascript')){
       var target = $(this).parents('.cat-tabbing-sc').find('.custom-form-tabs .form-tab.active');
        // Smooth scroll to the target section
        if(target.length){
          $('html, body').animate({
            scrollTop: target.offset().top - 20
          }, 800); // 800ms animation duration
        }
      }
    });
});






